export default{
	//判断数据是否为空，添加暂无数据图标
    dataValidation:function(obj,height){
		let url = require('../src/assets/images/none.png');
		let markedelement = document.getElementById(obj)
		let markbox=document.createElement('div')
			markbox.style.height=height+'px';
			markbox.style.width='100%';
			markbox.style.margin='0 auto';
			markbox.style.background='url('+url+') no-repeat center center';
			markbox.id='nodata_markbox'+obj
			if(!document.getElementById(markbox.id)){
				markedelement.appendChild(markbox)
			}
			
    },
    changeFontSize:function(){
  		let screenwidth = screen.width;
	  	if(screenwidth==1920){
				document.getElementsByTagName('html')[0].style.fontSize=75+'px';
	  	}
	  	if(screenwidth==1366){
				document.getElementsByTagName('html')[0].style.fontSize=60+'px';
	  	}
  	},
  	//iframe添加全屏按钮
    iframeScreenButton:function(urls) {
    	let eleIframe = document.getElementsByTagName('iframe')[0];
		if(eleIframe){
			let iframeUrl = eleIframe.src;
			let eleParent = document.getElementsByTagName('iframe')[0].parentNode;
			let eleButton = document.createElement('div');
			eleParent.style.position = 'relative';
			eleButton.style.position = 'absolute';
			eleButton.style.bottom = '10px';
			eleButton.style.right = '10px';
			eleButton.style.fontSize = '30px';
			eleButton.style.cursor='pointer';
			
			eleParent.appendChild(eleButton);
			if(iframeUrl){
				eleButton.style.width = '70px';
				let btntexticon = document.createElement('span');
				let btntext = document.createElement('span');
				btntext.innerText='全屏';
				btntexticon.style.padding='0';
				btntexticon.style.marginLeft='10px';
				btntexticon.style.float='left';
				btntexticon.style.height='30px';
				btntexticon.style.display='inline-block';
				btntexticon.style.lineHeight='30px';
				btntexticon.style.fontSize='16px';
				btntext.style.float='left';
				btntext.style.fontSize='12px';
				btntext.style.width = '40px';
				btntext.style.height='30px';
				btntext.style.display='inline-block';
				btntext.style.lineHeight='30px';
				btntext.style.padding='0';
				btntext.style.margin='0';
				btntexticon.className ='el-icon-thirdicon-knodetailfullscreen'
				eleButton.appendChild(btntexticon);
				eleButton.appendChild(btntext);
				eleButton.style.background = '#f3f3f3';
				eleButton.style.height = '30px';
				eleButton.style.padding='0px';
				eleButton.style.margin='0px';
				eleButton.style.textAlign = 'center';
				eleButton.style.lineHeight = '30px';
				eleButton.onclick = function() {
				window.open(iframeUrl)
				}
			}else{
				eleButton.className ='el-icon-thirdicon-knodetailfullscreen'
				eleButton.style.width = '30px';
				eleButton.style.background = '#ddd';
				eleButton.style.height = '30px';
				eleButton.style.textAlign = 'center';
				eleButton.style.lineHeight = '30px';

				eleButton.onclick = function(){
				$.ajax({
					type:'post',
					data:{detail:eleIframe.srcdoc},
					url:'http://datagalaxy.yeesight.com/v2/admin/index.php?m=Api&c=Content&a=openDemo',
//					url:'http://47.93.51.30/v3/admin/index.php?m=Api&c=Content&a=openDemo',
					success: function(data){
						if(data.status==1){
							var tempwindow=window.open('_blank'); // 先打开页面
								tempwindow.location=data.data; // 后更改页面地址,不然弹窗会被拦截
//							window.open(data.data)
						}else{
//							console.log(data);
						}
					},
					error:function(){
//						console.log(data);
					}
				})
				}

			}
		}
   },
   
   
}


//////////////////
// WEBPACK FOOTER
// ./commonFunction/common.js
// module id = null
// module chunks = 